import {
	MANAGE_ARTICLES_GET_ARTICLES,
	MANAGE_ARTICLES_GET_ARTICLES_FAILURE,
	MANAGE_ARTICLES_GET_ARTICLES_SUCCESS,
	MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES,
	MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_FAILURE,
	MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_SUCCESS,
	MANAGE_ARTICLES_REMOVE_ARTICLES,
	MANAGE_ARTICLES_REMOVE_ARTICLES_FAILURE,
	MANAGE_ARTICLES_REMOVE_ARTICLES_SUCCESS,
	MANAGE_ARTICLES_PROPS_CHANGED,
} from "./actions";

export const dispatchOnManageArticlesGetArticles = () => dispatch => {
	dispatch({type: MANAGE_ARTICLES_GET_ARTICLES});
};

export const dispatchOnManageArticlesGetArticlesSuccess = (response) => dispatch => {
	dispatch({
		type: MANAGE_ARTICLES_GET_ARTICLES_SUCCESS,
		articles: response.data,
		pagination: response.pagination,
	});
};

export const dispatchOnManageArticlesGetArticlesFailure = (error) => dispatch => {
	dispatch({type: MANAGE_ARTICLES_GET_ARTICLES_FAILURE, error});
};



export const dispatchOnManageArticlesPublishOrUnpublishArticles = () => dispatch => {
	dispatch({type: MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES});
};

export const dispatchOnManageArticlesPublishOrUnpublishArticlesSuccess = (article, index, response) => dispatch => {
	dispatch({
		type: MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_SUCCESS,
		article,
		index,
		response
	});
};

export const dispatchOnManageArticlesPublishOrUnpublishArticlesFailure = (error) => dispatch => {
	dispatch({type: MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_FAILURE, error});
};


export const dispatchOnManageArticlesRemoveArticles = () => dispatch => {
	dispatch({type: MANAGE_ARTICLES_REMOVE_ARTICLES});
};

export const dispatchOnManageArticlesRemoveArticlesSuccess = (article, index, response) => dispatch => {
	dispatch({
		type: MANAGE_ARTICLES_REMOVE_ARTICLES_SUCCESS,
		article,
		index,
		response
	});
};

export const dispatchOnManageArticlesRemoveArticlesFailure = (error) => dispatch => {
	dispatch({type: MANAGE_ARTICLES_REMOVE_ARTICLES_FAILURE, error});
};



export const dispatchOnManageArticlesPublishOrUnpublishModeChanged = (article, index, inPublishMode) => dispatch => {
	dispatch({
		type: MANAGE_ARTICLES_PROPS_CHANGED,
		article,
		index,
		inPublishMode
	});
};

export const dispatchOnManageArticlesRemoveModeChanged = (article, index, inRemoveMode) => dispatch => {
	dispatch({
		type: MANAGE_ARTICLES_PROPS_CHANGED,
		article,
		index,
		inRemoveMode
	});
};

export const dispatchOnManageArticlesClickedArticleIdChanged = (clickedArticleId) => dispatch => {
	dispatch({
		type: MANAGE_ARTICLES_PROPS_CHANGED,
		clickedArticleId,
	})
};